import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'history-bill',
    templateUrl: '../../templates/partials/history-bill.html'
})

export class HistoryBillComponent implements OnInit {

    @Input() paidBill;
    @Output() showModal = new EventEmitter();
    constructor(private router: Router) { }

    public showModalAddCharge(){
        this.showModal.emit();
    }

    public reSendCharge() {
        //console.log("reSend");
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/history-bill.component.ts